import { render, staticRenderFns } from "./prescriptionSupervisionList.vue?vue&type=template&id=d2c41e6e&scoped=true"
import script from "./prescriptionSupervisionList.vue?vue&type=script&lang=js"
export * from "./prescriptionSupervisionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c41e6e",
  null
  
)

export default component.exports